module.exports = __webpack_public_path__ + "img/FondoNoah2.c8f95761.jpg";